// Icon.js
const icon = {
    // ✏️ 
    pencil: {
        className: "bi bi-pencil", style: { fontSize: "20px", color: "black" },
    },
    pencil2: {
        className: "bi bi-pencil", style: { fontSize: "12px", color: "white" },
    },
    // ➕
    plus: {
        className: "bi bi-plus", style: { fontSize: "15px", color: "black" },
    },
    // ⏳
    time: {
        className: "bi bi-clock", style: { fontSize: "15px", color: "black" },
    },
    // 🗑️
    trash: {
        className: "bi bi-trash", style: { fontSize: "20px", color: "black" },
    },
    // ✖️
    view: {
        className: "bi bi-eye", style: { fontSize: "20px", color: "black" },
    },
    bell: {
        className: "bi bi-bell", style: { fontSize: "15px", color: "black" },
    },
    save: {
        className: "bi bi-floppy", style: { fontSize: "15px", color: "black" },
    },

    // Icons de Status
    iniciar: {
        className: "bi bi-info-circle", style: { fontSize: "20px", color: '#008AC9' },
    },
    cancelado: {
        className: "bi bi-x-circle", style: { fontSize: "20px", color: "red" },
    },
    progresso: {
        className: "bi bi-arrow-repeat text-warning", style: { fontSize: "20px", color: '#3263AE' },
    },
    execucao: {
        className: "bi bi-play-circle", style: { fontSize: "20px", color: "#E47411" },
    },
    revisao: {
        className: "bi bi-search", style: { fontSize: "20px", color: "#6A1B9A" },
    },
    concluido: {
        className: "bi bi-check-circle", style: { fontSize: "20px", color: "#1A7958" },
    },

    criar: {
        className: "bi bi-plus-circle", style: { fontSize: "12px", color: "#ffc107" },
    },
    agendado: {
        className: "bi bi-calendar-check", style: { fontSize: "12px", color: "#3263AE" },
    },
    concluida: {
        className: "bi bi-check-circle", style: { fontSize: "12px", color: "#1A7958" },
    },
    expirada: {
        className: "bi bi-x-circle", style: { fontSize: "12px", color: "red" },
    },
    ticket: {
        className: "bi bi-ticket-detailed", style: { fontSize: "12px", color: "#CCAE57" },
    },
    evento: {
        className: "bi bi-calendar-event", style: { fontSize: "12px", color: "#28a745" },
    },

    // Mais Emojis: 📝 📅 📊 📈 ❌ ✅ 📌 🔒 🌍 ➡
};

module.exports = {
    icon,
};
